import { useRef, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import AppModal from "../common/AppModal";
import ReusableForm from "../common/ReusableForm";
import { addStaffValidationSchema } from "../forms/validationSchemas";
import DigitalPinForm from "../common/DigitalPinForm";
import StaffViewModal from "./staff-view-modal";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import ToolTip from "../common/ToolTip";
import { Roles } from "../../utils/constants";
import { editStaffData, reset } from "../../features/staff/staffSlice";
import AppButton from "../common/AppButton";
import AppErrorMessage from "../common/AppErrorMessage";
import { styles } from "./styles";
import StaffPerissionEdit from "./staff_Permission_edit";

interface IProps {
  item: any;
  img?: any;
  type?: any;
  title?: any;
  GetAllStaffPermissions?: any;
  pharmacy_id?: any;
  setOpenSnackEditbar?: any;
  setOpenErrorToast?: any;
}
export const StaffEditModel = ({
  item,
  img,
  type,
  title,
  GetAllStaffPermissions,
  setOpenSnackEditbar,
  setOpenErrorToast,
}: IProps) => {
  const pharmacyId = localStorage?.getItem("pharmacyId");
  const formRef = useRef<any>(null);
  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const {
    isEditStaffDataLoading,
    isEditStaffDataError,
    editStaffDataMessage,
  }: any = useAppSelector((state) => state.staff);

  const dispatch = useAppDispatch();
  const handleSubmitUpdateRegister = (values: any) => {
    const obj = {
      id: item?.id,
      pharmacy_id: pharmacyId,
      ...values,
    };
    delete obj?.pin;
    dispatch(editStaffData(obj)).then((res: any) => {
      if (res.payload.success === true) {
        setOpenSnackEditbar(true);
        handleCloseModal();
        GetAllStaffPermissions();
      } else {
        setOpenErrorToast(true)
      }
    });
  };

  const handleSubmitEditPin = (value: any) => {
    const obj: any = {
      id: item?.id,
      pharmacy_id: pharmacyId,
      pin: value,
    };
    dispatch(editStaffData(obj)).then((res: any) => {
      if (res.payload.success === true) {
        handleCloseModal();
        setOpenSnackEditbar(true);
        GetAllStaffPermissions();
      } else {
        setOpenErrorToast(true);
      }
    });
  };

  const options = Object.keys(Roles)
    .filter((key: any) => isNaN(Number(key)))
    .map((key: any) => ({
      id: Roles[key as keyof typeof Roles],
      name: key.charAt(0).toUpperCase() + key.slice(1).toLowerCase(),
    }));

  const genderOptions = [
    { id: "1", name: "Male" },
    { id: "2", name: "Female" },]
  const data = [
    {
      id: 1,
      title: "Name",
      name: "name",
      type: "text",
      placeholder: "Enter Name",
    },
    {
      id: 2,
      type: "select",
      title: "Role",
      name: "role_id",
      placeholder: "Enter Role",
      options: options,
    },

    {
      id: 3,
      title: "Email",
      name: "email",
      type: "email",
      placeholder: "Enter Email",
    },
    {
      id: 4,
      title: "Number",
      name: "contact_number",
      type: "contact_number",
      placeholder: "03xx xxxxxxxxx",
    },
    {
      id: 5,
      title: "Address",
      name: "address",
      type: "text",
      placeholder: "Enter Address",
    },
    {
      id: 6,
      title: "Gender",
      name: "gender",
      type: "select",
      placeholder: "Enter Gender",
      options: genderOptions
    },
  ];

  return (
    <>
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          justifyContent: "flex-end",
          flexWrap: "wrap",
        }}
      >
        <ToolTip
          width="18px"
          height="18px"
          IconType={img}
          title={title}
          onClick={handleOpenModal}
          style={{
            ...styles.icon,
            cursor: !item?.isActive ? "not-allowed" : "pointer",
          }}
          disabled={!item?.isActive}
        />
      </Box>
      <AppModal
        title={
          type === "Edit"
            ? "Edit Staff"
            : type === "PinIcon"
              ? "Assign Pin"
              : type === "View"
                ? "View Details"
                : type === "Key"
                  ? "Edit User Permissions"
                  : ""
        }
        open={openModal}
        handleClose={handleCloseModal}
        fullScreen={false}
        maxWidth="md"
      >
        <>
          {type === "Edit" ? (
            <ReusableForm
              handleSubmit={handleSubmitUpdateRegister}
              data={data}
              validationSchema={addStaffValidationSchema}
              initialValue={item}
              isEdited={true}
            />
          ) : type === "PinIcon" ? (
            <DigitalPinForm
              title=" Create 6 Digit Pin for your staff member"
              length={6}
              onSubmit={handleSubmitEditPin}
              ref={formRef}
              initialPin={item.pin}
            />
          ) : type === "View" ? (
            <StaffViewModal item={item} />
          ) : type === "Key" ? (
            <StaffPerissionEdit item={item} />
          ) : (
            ""
          )}

          {type !== "View" && (
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                marginTop: 2,
              }}
            >
              <Box>
                {/* {isEditStaffDataError && (
                  <AppErrorMessage message={editStaffDataMessage} />
                )} */}
              </Box>
              <AppButton
                variant="contained"
                color="primary"
                type="submit"
                title={
                  isEditStaffDataLoading ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    "Updated"
                  )
                }
                onClick={() =>
                  type === "Edit"
                    ? document.querySelector("form")?.dispatchEvent(
                      new Event("submit", {
                        cancelable: true,
                        bubbles: true,
                      })
                    )
                    : type === "PinIcon"
                      ? formRef.current?.submitForm()
                      : type === "Key"
                        ? handleCloseModal()
                        : ""
                }
                sx={{ float: "right" }}
                disabled={isEditStaffDataLoading}
              />
            </Box>
          )}
        </>
      </AppModal>
    </>
  );
};
